import { useState } from "react";
import { useCurrentUser } from "@/features/auth/useCurrentUser";
import { useFeatureFlags } from "@/features/featureFlags/hooks";
import {
  QuotationDetailModeToggle,
  type QuotationDetailMode,
} from "./quotation/QuotationDetailModeToggle";
import { QuotationDetailOfficialPage } from "./quotation/QuotationDetailOfficialPage";
import { QuotationDetailManualPage } from "./quotation/QuotationDetailManualPage";
import "./QuotationWorkspace.css";
import "@/components/quotation/quotation-mock.css";
import "./quotation/QuotationDetail.css";

function QuotationDetailLoadingFallback() {
  return (
    <div
      style={{
        maxWidth: "800px",
        margin: "0 auto",
        padding: "1.5rem",
        color: "var(--login-muted)",
        fontFamily: "'DM Sans', sans-serif",
      }}
    >
      Carregando cotação...
    </div>
  );
}

export function QuotationDetailPage() {
  const currentUserQuery = useCurrentUser();
  const [activeMode, setActiveMode] = useState<QuotationDetailMode>("manual");

  const currentUser = currentUserQuery.data;
  const isSuper = currentUser?.role === "super";
  const featureFlagsQuery = useFeatureFlags(isSuper);
  const featureFlags = featureFlagsQuery.data;

  const manualMode = featureFlags?.feature_super_quotation_manual_mode === true;

  if (currentUserQuery.isLoading) {
    return <QuotationDetailLoadingFallback />;
  }

  if (isSuper && featureFlagsQuery.isLoading) {
    return <QuotationDetailLoadingFallback />;
  }

  if (isSuper && manualMode) {
    const topSlot = (
      <QuotationDetailModeToggle
        activeMode={activeMode}
        onChange={setActiveMode}
      />
    );

    if (activeMode === "manual") {
      return <QuotationDetailManualPage topSlot={topSlot} />;
    }

    return <QuotationDetailOfficialPage topSlot={topSlot} />;
  }

  return <QuotationDetailOfficialPage />;
}
